import axios from '../axios';
// 证件 列表
export const getBaseEmployeeCertPage = data => {
    return axios({
        url: '/api/sys/base/getBaseEmployeeCertPage',
        method: 'post',
        data
    })
};
// 证件 保存
export const saveBaseEmployeeCert = data => {
    return axios({
        url: '/api/sys/base/saveBaseEmployeeCert',
        method: 'post',
        data
    })
};
// 证件 修改
export const updateBaseEmployeeCert = data => {
    return axios({
        url: '/api/sys/base/updateBaseEmployeeCert',
        method: 'post',
        data
    })
};
// 证件 删除
export const deleteBaseEmployeeCerts = data => {
    return axios({
        url: '/api/sys/base/deleteBaseEmployeeCerts',
        method: 'post',
        data
    })
};


// WEBPACK FOOTER //
// ./src/api/moudules/certificate.js